module.exports = __webpack_public_path__ + "img/info.b82351f2.svg";